import { ReactNode } from 'react';
import { ActionIconGroup } from '@mantine/core';

type TouringCardActionsPropsType = {
  children: ReactNode;
};

export const TouringCardActions: React.FC<TouringCardActionsPropsType> = ({
  children,
}) => {
  return <ActionIconGroup>{children}</ActionIconGroup>;
};
